module.exports = __webpack_public_path__ + "img/taText_new_logo.9b2a9388.png";